import { ReferenceMap } from '../../shared.types';
import { Rules } from '../types';

import actionRulesMap from '../data/action-map.json';
import { RuleScope } from '../constants';
import validationsMap from '../data/validation-map.json';

export type GetKitchenReferenceRulesParams = {
	ruleScope: number;
	refMap: ReferenceMap;
};

export const getKitchenReferenceRules = (params: GetKitchenReferenceRulesParams): Rules => {
	const { ruleScope, refMap } = params;
	const { components } = refMap?.kitchenDesign?.context ?? { components: null };

	const response = { action: [], validation: [] };

	const scopeEntries = Object.entries(RuleScope).map(([name, value]) => ({ name, value }));
	scopeEntries.sort((a, b) => a.value - b.value);

	for (const scope of scopeEntries) {
		if (scope.value >= ruleScope) {
			const scopeRules = {
				action: actionRulesMap[scope.name] ?? []
			};

			response.action = [...response.action, ...scopeRules.action];
		}
	}

	// Validation rules in reverse order
	const reversedScopeEntries = [...scopeEntries].reverse();
	for (const scope of reversedScopeEntries) {
		if (scope.value >= ruleScope) {
			const scopeRules = {
				validation: validationsMap[scope.name] ?? []
			};

			response.validation = [...response.validation, ...scopeRules.validation];
		}
	}

	// Handle panel item events
	const panelItem = refMap?.panelItem ?? null;
	if (panelItem) {
		const skuItem = components.findSku(panelItem.item.sku);
		const { category } = skuItem;

		const categoryRules: Rules = category?.rules ?? { action: [], validation: [] };
		const skuRules: Rules = skuItem.rules ?? { action: [], validation: [] };

		response.action = [...response.action, ...categoryRules.action, ...skuRules.action];
		response.validation = [...response.validation, ...categoryRules.validation, ...skuRules.validation];
	}

	// console.log('getKitchenReferenceRules', response);
	return response;
};
